import styled from 'styled-components';

export const TotalsContainer = styled.div`
  padding: 1rem 1.5rem;
`;
